import { Zap } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)]">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden border-r border-border"
        style={{ backgroundImage: "linear-gradient(135deg, rgba(11,15,23,0.85), rgba(19,27,42,0.9)), url('https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-md bg-primary flex items-center justify-center shadow-[0_0_20px_rgba(245,158,11,0.4)]">
            <Zap className="w-6 h-6 text-primary-foreground" strokeWidth={2.5} />
          </div>
          <div className="font-display text-2xl font-extrabold uppercase">NEXO<span className="text-primary">LOG</span></div>
        </div>
        <div>
          <h1 className="font-display text-5xl font-extrabold uppercase leading-none mb-4">Do CD à<br /><span className="text-primary">ponta</span>, rastreado.</h1>
          <p className="text-muted-foreground max-w-md">Gestão logística ponta a ponta — pedidos, separação, expedição e recebimento por bipagem.</p>
        </div>
        <div className="text-xs text-muted-foreground font-mono uppercase tracking-widest">NEXO LOG · Plataforma de Logística</div>
      </div>

      <div className="flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-sm space-y-5">
          <div className="lg:hidden flex items-center gap-3 mb-4 justify-center">
            <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center"><Zap className="w-5 h-5 text-primary-foreground" /></div>
            <div className="font-display text-2xl font-extrabold uppercase">NEXO<span className="text-primary">LOG</span></div>
          </div>
          <div>
            <h2 className="font-display text-3xl font-bold uppercase">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children}
          {footer}
        </div>
        <div className="mt-10 text-[11px] text-muted-foreground/70 tracking-wide">Desenvolvido por <span className="text-muted-foreground">Elite Tecnologia</span></div>
      </div>
    </div>
  );
}
